import React, { useState } from "react";
import styles from "./styles.module.scss";
import { ArrowIcon } from "../Icons";

const VIDEO_ID = "Vo0ndeHO_QU";

interface BeneficiosV2Props {
  signupLink: string;
}

type Item = { text: string; icon: string; iconTitle?: string };

const ICON_BASE = "/images-capa2/beneficios";

const BENEFICIOS: Item[] = [
  { text: "Portfólio diverso de produtos de viagem", icon: `${ICON_BASE}/b-0.png`, iconTitle: "ícone brilho" },
  { text: "Marcas consolidadas no mercado", icon: `${ICON_BASE}/b-1.png`, iconTitle: "ícone alvo" },
  { text: "Cadastro gratuito", icon: `${ICON_BASE}/b-2.png`, iconTitle: "ícone cadastro" },
  { text: "Flexibilidade de divulgação", icon: `${ICON_BASE}/b-3.png`, iconTitle: "ícone relógio" },
  { text: "Suporte e comunidade ativa", icon: `${ICON_BASE}/b-4.png`, iconTitle: "ícone comunidade" },
  { text: "Conteúdo educacional contínuo", icon: `${ICON_BASE}/b-5.png`, iconTitle: "ícone capelo" },
  { text: "Possibilidade de crescimento escalável", icon: `${ICON_BASE}/b-6.png`, iconTitle: "ícone seta escalável" },
  { text: "Acompanhamento constante com time de analistas", icon: `${ICON_BASE}/b-7.png`, iconTitle: "ícone fone" },
  { text: "Estratégias de divulgação, baseado em números", icon: `${ICON_BASE}/b-8.png`, iconTitle: "ícone gráfico" },
  { text: "Quanto mais dedicação, mais resultados", icon: `${ICON_BASE}/b-9.png`, iconTitle: "ícone raio" },
];

const DIFERENCIAIS: Item[] = [
  { text: "Possibilidade de publicidade paga", icon: `${ICON_BASE}/d-0.png`, iconTitle: "ícone brilho" },
  { text: "Relatório e Dashboards das suas vendas", icon: `${ICON_BASE}/d-1.png`, iconTitle: "ícone alvo" },
  { text: "Academia Parceiros Promo", icon: `${ICON_BASE}/d-2.png`, iconTitle: "ícone relógio" },
  { text: "Maior grupo de tecnologia para turismo", icon: `${ICON_BASE}/d-3.png`, iconTitle: "ícone usuários" },
];

const BeneficiosV2: React.FC<BeneficiosV2Props> = ({ signupLink }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="beneficios" className={styles.beneficios}>
      <div className={styles.head}>
        <h2>Benefícios e Diferenciais do Parceiros Promo</h2>
        <p>
          A nossa parceria é completa! Todo Parceiro Promo terá todo suporte e
          ferramentas para fazer divulgações que convertem em vendas.
        </p>
      </div>

      <h3 className={`${styles.subhead} ${styles.subheadBenefits}`}>
        Principais Benefícios:
      </h3>

      <div className={styles.benefitGrid}>
        {BENEFICIOS.map((b) => (
          <div key={b.text} className={styles.benefitCard}>
            <span className={styles.benefitIcon}>
              <img
                src={b.icon}
                alt={b.iconTitle ?? `Ícone ${b.text}`}
                title={b.iconTitle ?? b.text}
              />
            </span>
            <h4 className={styles.benefitText}>{b.text}</h4>
          </div>
        ))}
      </div>

      <h3 className={styles.subhead}>Nossos diferenciais</h3>

      <div className={styles.difGrid}>
        {DIFERENCIAIS.map((d) => (
          <div key={d.text} className={styles.difCard}>
            <span className={styles.difIcon}>
              <img
                src={d.icon}
                alt={d.iconTitle ?? `Ícone ${d.text}`}
                title={d.iconTitle ?? d.text}
              />
            </span>
            <h4 className={styles.difText}>{d.text}</h4>
          </div>
        ))}
      </div>

      <div className={styles.ctaRow}>
        <p>
          Só com o Parceiros Promo você desfruta de benefícios e diferenciais
          que fazem você lucrar muito mais em sua divulgação!
        </p>
        <a
          href={signupLink}
          className={styles.ctaButton}
          title="Quero ser um Parceiro"
        >
          <span>Quero ser um Parceiro!</span>
          <ArrowIcon />
        </a>
      </div>

      <div className={styles.pronto}>
        <div className={styles.prontoText}>
          <h2>Pronto para começar?</h2>
          <p>
            Embarque nessa parceria que vai transformar sua vida financeira. Ser
            um Parceiro Promo é ter liberdade e autonomia para sonhar sem
            limites!
          </p>
          <a
            href={signupLink}
            className={styles.prontoButton}
            title="Quero ser um Parceiro"
          >
            <span>Quero ser um Parceiro!</span>
            <ArrowIcon />
          </a>
        </div>
        <div className={styles.prontoMedia}>
          {playing ? (
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
              title="Parceiros Promo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              className={styles.prontoPlay}
              onClick={() => setPlaying(true)}
              aria-label="Assistir vídeo"
            >
              <img
                src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt="Pronto para começar"
                title="Pronto para começar"
                onError={(e) => {
                  const img = e.currentTarget as HTMLImageElement;
                  if (img.src.includes("maxresdefault")) {
                    img.src = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;
                  } else if (img.src.includes("hqdefault")) {
                    img.src = "/images-capa2/beneficios/pronto.png";
                  } else {
                    img.style.display = "none";
                  }
                }}
              />
              <span className={styles.prontoPlayIcon} aria-hidden="true">
                <svg viewBox="0 0 68 48" width="68" height="48">
                  <path
                    d="M66.52 7.74a8 8 0 0 0-5.63-5.66C55.93 0.72 34 0.72 34 0.72s-21.93 0-26.89 1.36A8 8 0 0 0 1.48 7.74C0.12 12.7 0.12 24 0.12 24s0 11.3 1.36 16.26a8 8 0 0 0 5.63 5.66C12.07 47.28 34 47.28 34 47.28s21.93 0 26.89-1.36a8 8 0 0 0 5.63-5.66C67.88 35.3 67.88 24 67.88 24s0-11.3-1.36-16.26z"
                    fill="#f00"
                  />
                  <path d="M45 24 27 14v20" fill="#fff" />
                </svg>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default BeneficiosV2;
